/*
 * @Author: cn1994
 * @Date: 2025-04-10 14:21:24
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-15 13:38:21
 * @Description: file content
 */
// import "babel-polyfill";
import Vue from "vue";
import localforage from 'localforage'
import '@/directives'

import { slsTracker, initErrorTracking } from './utils/slsTracker'
// 初始化错误追踪
initErrorTracking();
// Vue错误处理
Vue.config.errorHandler = (err, vm, info) => {
  slsTracker.send({
    errorType: 'vue_error',
    message: err.message,
    stack: err.stack,
    component: vm?.$options?.name,
    info: info,
  });
};

import VueTour from 'vue-tour'
import  'vue-tour/dist/vue-tour.css'
Vue.use(VueTour)
Vue.use(localforage)
Vue.prototype.$localforage = localforage;
const dataCenterBase = localforage.createInstance({
  name: 'dataCenterBase'
})
Vue.prototype.$dataCenterBase = dataCenterBase;

import { createPinia, PiniaVuePlugin } from 'pinia'
import persistedstate from 'pinia-plugin-persistedstate'
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vant from 'vant';
import 'vant/lib/index.css';

import "./assets/css/normalize.css";
import "./assets/css/customize.css";
import "./assets/css/sales.css";
import "./assets/css/basic.less";
import VueProgressBar from "vue-progressbar";
import draggable from "vuedraggable";
import App from './App.vue';

import VueClipboard from "vue-clipboard2";//剪切板
Vue.use(VueClipboard);

//销售2.0
import "@/common/selectLoadMore";
import './assets/css/element-reset.less'
import './assets/css/iconfont.css'
import "./assets/css/font.css";
import './assets/css/common.less'
import './assets/css/commonV3/index.less'
import './assets/css/commonV3/tailwind.css'

import CustomComponents from './components/index'
import LsUI from './lsUI/index'
import urls from '@/config/imageURL'
import router from "./router";
Vue.use(router)

import textsMixin from './mixin/texts'
import medicalList from "./pages/medical/config/medical";
import checkRoleMixin from './mixin/checkRoleMixin'

Vue.use(Vant);

// 2023年12月28日17:24:59
// 新增埋点mixin
import volcengineMixin from './mixin/volcengine'

import VueCookies from 'vue-cookies';
Vue.use(VueCookies)

import ClickTracking from './directives/tracking';
Vue.directive('click-tracking', ClickTracking);

const pinia = createPinia()
pinia.use(persistedstate)
Vue.use(PiniaVuePlugin)
Vue.use(CustomComponents)
Vue.use(LsUI)

Vue.prototype.$urls = urls
Vue.use(Antd);
Vue.prototype.$antdconfirm = Vue.prototype.$confirm;
Vue.use(draggable);
Vue.use(ElementUI)
Vue.prototype.medicalList=medicalList //医疗数据

window.eventBus = new Vue(); //注册全局事件对象

Vue.use(VueProgressBar, {
  color: "#eeeeee",
  failedColor: "#874b4b",
  thickness: "2px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s"
  },
  autoRevert: true,
  location: "top",
  inverse: false
});
Vue.config.productionTip = false;

new Vue({
  pinia,
  router,
  render: h => h(App),
  data: {
    eventHub: new Vue()
  }
}).$mount("#app");
//1.在main.js 页面里添加自定义指令
Vue.directive('title', {//单个修改标题
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

Vue.mixin(textsMixin)
Vue.mixin(volcengineMixin)
Vue.mixin(checkRoleMixin)

//分页转换
Vue.prototype.switchPage = function (page, pageSize) {
  let start = 0;
  let end = 1;
  start = (page - 1) * pageSize;
  end = page * pageSize - 1;
  return { start, end };
};

//价格舍弃且转为字符串
Vue.prototype.priceTwoFixed = function (data) {
  // return (Math.floor(num * 100) / 100).toFixed(2)
  let num = String(data)
  let numSplit = num.split('.')
  if (numSplit.length <= 1) {
    // 没有小数
    return Number(num)
  } else {
    // 有小数
    if (numSplit[1].length <= 2) {
      // 只有1位或者2位小数
      return Number(num)
    } else {
      // 超出2位小数
      // 截取保存2位小数
      return Number(`${numSplit[0]}.${numSplit[1].substring(0, 2)}`)
    }
  }
}
